module.exports = __webpack_public_path__ + "img/logo-veto.fffe3d62.png";